import { render, staticRenderFns } from "./BirthInfo.vue?vue&type=template&id=65c1c902&scoped=true&"
import script from "./BirthInfo.vue?vue&type=script&lang=js&"
export * from "./BirthInfo.vue?vue&type=script&lang=js&"
import style0 from "./BirthInfo.vue?vue&type=style&index=0&id=65c1c902&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c1c902",
  null
  
)

export default component.exports